module.exports = __webpack_public_path__ + "static/032.thumb-c8d27cb3b2a785a9ee01fb3d48cd5ec1.jpg";